//Author June Leow
//Date June 25th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, deleteAPICallGenerator, callBackGenerator, showMessage} from '../../util/util';
import DatePicker from 'react-datepicker';
import {Card, CardHeader, CardBody, Input, Button, Row, Col} from 'reactstrap';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import MyPlacesAutocomplete from '../util/my-places-autocomplete';
import moment from 'moment';
import MyFormStep from '../util/my-form-step';
import {NavLink, useNavigate} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
import './login.css';
//initialize the state
const initialState = {
  session: {},
  errorMessage:'',
  email:'',
  fname:'',
  lname:'',
  licenseState:'',
  licenseNumber:'',
  states:[
    {key:'Alabama',value:'Alabama'},{key:'Alaska',value:'Alaska'},{key:'Arizona',value:'Arizona'},{key:'Arkansas',value:'Arkansas'},{key:'California',value:'California'},{key:'Colorado',value:'Colorado'},{key:'Connecticut',value:'Connecticut'},{key:'Delaware',value:'Delaware'},{key:'Florida',value:'Florida'},{key:'Georgia',value:'Georgia'},{key:'Hawaii',value:'Hawaii'},{key:'Idaho',value:'Idaho'},{key:'Illinois',value:'Illinois'},{key:'Indiana',value:'Indiana'},{key:'Iowa',value:'Iowa'},{key:'Kansas',value:'Kansas'},{key:'Kentucky',value:'Kentucky'},{key:'Louisiana',value:'Louisiana'},{key:'Maine',value:'Maine'},{key:'Maryland',value:'Maryland'},{key:'Massachusetts',value:'Massachusetts'},{key:'Michigan',value:'Michigan'},{key:'Minnesota',value:'Minnesota'},{key:'Mississippi',value:'Mississippi'},{key:'Missouri',value:'Missouri'},{key:'Montana',value:'Montana'},{key:'Nebraska',value:'Nebraska'},{key:'Nevada',value:'Nevada'},{key:'New Hampshire',value:'New Hampshire'},{key:'New Jersey',value:'New Jersey'},{key:'New Mexico',value:'New Mexico'},{key:'New York',value:'New York'},{key:'North Carolina',value:'North Carolina'},{key:'North Dakota',value:'North Dakota'},{key:'Ohio',value:'Ohio'},{key:'Oklahoma',value:'Oklahoma'},{key:'Oregon',value:'Oregon'},{key:'Pennsylvania',value:'Pennsylvania'},{key:'Rhode Island',value:'Rhode Island'},{key:'South Carolina',value:'South Carolina'},{key:'South Dakota',value:'South Dakota'},{key:'Tennessee',value:'Tennessee'},{key:'Texas',value:'Texas'},{key:'Utah',value:'Utah'},{key:'Vermont',value:'Vermont'},{key:'Virgin Islands',value:'Virgin Islands'},{key:'Virginia',value:'Virginia'},{key:'Washington',value:'Washington'},{key:'Washington DC',value:'Washington DC'},{key:'West Virginia',value:'West Virginia'},{key:'Wisconsin',value:'Wisconsin'},{key:'Wyoming',value:'Wyoming'}
  ],
  phone:'',
  notifyEmails:'',
  password:'',
  showPassword:false,
  isFocused:false,
  preferredCommunication:'',
  taxID:'',
  eoExpirationDate:'',

  newLicenseType:'Unknown',
  newLicenseExpiration:'',

  street:'',
  city:'',
  county:'',
  state:'',
  zip:'',

  billingStreet:'',
  billingCity:'',
  billingCounty:'',
  billingState:'',
  billingZip:'',
  billingName:'',

  lat:'',
  lng:'',

  steps:['General Information','Address','Review'],
  maxStep:0,
  currentStep:0,
  submitDisabled:false,
};

//reducer function that perform state update
const reducer = getReducer();


const SignUp  = (props)=>{
  const controller = new AbortController();

  const [state, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const history = useNavigate();
  const apiCallBack = callBackGenerator(setState);
  const httpPostNoToken = postAPICallGenerator(props, {signal:controller.signal, noToken:true});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(()=>{
    if(state.submitDisabled)
      handleStepAdvance();
  },[state.submitDisabled]);

  //non API call but simpyl manage state
  const buttonHandler=()=>{
    if(state.submitDisabled)
      return;

    setState({submitDisabled:true});
  }

  const updateStep=(step)=>{
    if(step<=state.maxStep)
      setState({currentStep:step});
  }

  //do checking on each step
  const submitForm=(e)=>{
    e.preventDefault();

    switch(state.currentStep){
      case 0:

        break;
      case 1:

        break;
      case 2:

        break;
      case 3:

        break;
      default:

        break;
    }
    handleStepAdvance();
  }

  const checkHandler=(e)=>{

    if(e.target.checked)
      copyAddress();

    setState({checked:e.target.checked});
  }

  const copyAddress=()=>{
    setState({billingStreet:state.street, billingCity:state.city, billingCounty:state.county, billingState:state.state, billingZip:state.zip});
  }

  const handleStepAdvance=()=>{
    let step = state.currentStep+1;
    console.log(step);
    //step 3 then finish, send create appraisal request
    if(step===3)
      createNewAppraiser();
    //else advance the step
    else{
      setState({currentStep:step});
      if(state.maxStep<step)
        setState({maxStep:step});
    }
  }

  const googlePlaceOnChange=(address)=>{
    if(address!==state.address){
      console.log(address)
      if(address.indexOf(',')!==-1 && address.length>10){
        setState({lat:null});
        setState({lng:null});

        geocodeByAddress(address)
          .then(
            results => {
              //always use the first returned result
              let targetResult = results[0];

              let addressComponents = targetResult.address_components;
              console.log(addressComponents);

              let streetNumber = '';
              let route = '';
              let city = '';
              let county = '';
              let state = '';
              let zip = '';

              //go through the address components and grab the street, city, county, state, and zip
              for(let i=0;i<addressComponents.length;i++){
                if(addressComponents[i].types[0]==='street_number')
                  streetNumber = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='route')
                  route = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='locality'&&addressComponents[i].types[1]==='political')
                  city = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='administrative_area_level_2'&&addressComponents[i].types[1]==='political')
                  county = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='administrative_area_level_1'&&addressComponents[i].types[1]==='political')
                  state = addressComponents[i].long_name;
                else if(addressComponents[i].types[0]==='postal_code')
                  zip = addressComponents[i].long_name;
              }


              let street = '';

              if(streetNumber!==''&&route!=='')
                street = streetNumber+' '+route;

              //get long lat
              getLatLng(targetResult)
                .then(
                  result=>{
                    if(result){
                      let lat = result.lat;
                      let lng = result.lng;
                      console.log(lng);

                      setState({lat:lat});
                      setState({lng:lng});
                    }
                  }
                )
                .catch(
                  error=>{
                    console.log(error);
                  }
                );

              if(street!==''){
                setState({street:street,address:street});
              }
              if(city!=='')
                setState({city:city});
              if(county!=='')
                setState({county:county});
              if(state!=='')
                setState({state:state});
              if(zip!=='')
                setState({zip:zip});
            })
          .catch(
            error => {
              console.log(error);
            }
          );
      }
      else{
        setState({address:address,street:address});
      }
    }
  }

  const handlePasswordFocus = () => {
    setState({ isFocused: true });
  };

  const handlePasswordBlur = () => {
    setState({ isFocused: false });
  };

  const handleToggle = () => {
    setState({ showPassword: !state.showPassword });
  }

  const isPasswordValid = (password, type='') => {
    const lowerCaseLetters = /[a-z]/g;
    const upperCaseLetters = /[A-Z]/g;
    const numbers = /[0-9]/g;
    const specialCharacters = /[!@#$%^&*]/g;
    const isLowerCaseValid = password.match(lowerCaseLetters);
    const isUpperCaseValid = password.match(upperCaseLetters);
    const isNumberValid = password.match(numbers);
    const isSpecialCharacterValid = password.match(specialCharacters);
    const isLengthValid = password.length >= 12;

    if(type === 'lowercase'){
      return(isLowerCaseValid);
    }else if(type === 'uppercase'){
      return(isUpperCaseValid);
    }else if(type === 'number'){
      return(isNumberValid);
    }else if(type === 'special'){
      return(isSpecialCharacterValid);
    }else if(type === 'length'){
      return(isLengthValid);
    }else{
      return (
        isLowerCaseValid &&
        isUpperCaseValid &&
        isNumberValid &&
        isSpecialCharacterValid &&
        isLengthValid
      );
    }
  };


  //API call
  const onSubmit=(e)=>{
    e.preventDefault();
    let callBack = (response)=>{
      let code = response.data.code;

      if(code!=='00'){
        setState({errorMessage:response.data.message});
      }
      else{
        let payload = response.data.data;
        let session = {
          first_name :payload.first_name,
          last_name :payload.last_name,
          email :payload.email,
          license_number :payload.license_number,
          state :payload.state,
        }
        setState({session:session,errorMessage:response.data.message});
      }
    };

    let parameters = [
      {
        field:'firstName',
        value:state.fname
      },
      {
        field:'lastName',
        value:state.lname
      },
      {
        field:'email',
        value:state.email
      },
      {
        field:'state',
        value:state.licenseState
      },
      {
        field:'licenseNumber',
        value:state.licenseNumber
      }
    ];

    httpPostNoToken('session/signUpCheck', parameters, '', '', callBack);
  }

  const createNewAppraiser=()=>{
    let callBack = (response)=>{console.log(response);
      let code = response.data.code;
      if(code==='00'){
        history('/');
        showMessage('success','Going back to log in page.');
      }
    };

    let parameters =[
      {
        field:'billingName',
        value:state.billingName
      },
      {
        field:'street',
        value:state.street
      },
      {
        field:'city',
        value:state.city
      },
      {
        field:'state',
        value:state.state
      },
      {
        field:'county',
        value:state.county
      },
      {
        field:'zip',
        value:state.zip
      },
      {
        field:'billingStreet',
        value:state.billingStreet
      },
      {
        field:'billingCity',
        value:state.billingCity
      },
      {
        field:'billingCounty',
        value:state.billingCounty
      },
      {
        field:'billingState',
        value:state.billingState
      },
      {
        field:'billingZip',
        value:state.billingZip
      },
      {
        field:'author',
        value:'New Appraiser'
      },
      {
        field:'firstName',
        value:state.session.first_name
      },
      {
        field:'lastName',
        value:state.session.last_name
      },
      {
        field:'email',
        value:state.session.email
      },
      {
        field:'notifyEmails',
        value:state.notifyEmails
      },
      {
        field:'password',
        value:state.password
      },
      {
        field:'phone',
        value:state.phone
      },
      {
        field:'preferredCommunication',
        value:state.preferredCommunication
      },
      {
        field:'lat',
        value:state.lat
      },
      {
        field:'lng',
        value:state.lng
      },
      {
        field:'taxID',
        value:state.taxID
      },
      {
        field:'eoExpirationDate',
        value:state.eoExpirationDate
      },
      {
        field:'licenseType',
        value:state.newLicenseType
      },
      {
        field:'licenseNumber',
        value:state.session.license_number
      },
      {
        field:'licenseState',
        value:state.session.state
      },
      {
        field:'licenseExpiration',
        value:state.newLicenseExpiration
      }
    ];
    httpPostNoToken('appraiser/create', parameters, 'Appraiser profile created successfully.','Oops, something went wrong and could not create the appraiser profile. Please try again later.',callBack);

  }

  //render
  const isLowerCaseValid = isPasswordValid(state.password, 'lowercase');
  const isUpperCaseValid = isPasswordValid(state.password, 'uppercase');
  const isSpecialCharacterValid = isPasswordValid(state.password, 'special');
  const isNumberValid = isPasswordValid(state.password, 'number');
  const isLengthValid = isPasswordValid(state.password, 'length');

  let valid = <i className="fa fa-check-circle-o"></i>;
  let invalid = <i className="fa fa-times-circle-o"></i>;

  const cssClasses = {
    input: 'form-control'
  }

  const inputProps = {
    value: state.address,
    onChange: googlePlaceOnChange,
    required: true
  }

  const defaultStyles = {
    autocompleteContainer: {
      position: 'absolute',
      top: '100%',
      backgroundColor: 'white',
      border: '1px solid #555555',
      width: '100%',
      zIndex:'9999',
    },
    autocompleteItem: {
      backgroundColor: '#ffffff',
      padding: '10px',
      color: '#555555',
      cursor: 'pointer',
    },
    autocompleteItemActive: {
      backgroundColor: '#fafafa'
    },
  }

  let states;

  if(state.states.length>0)
    states = state.states.map(
      (state, index)=>{
        return <option value={state.key} key={index}>{state.key}</option>;
      }
    );

  let date;
  if(state.eoExpirationDate!=='')
      date = moment(state.eoExpirationDate).toDate();

  let date2;
  if(state.newLicenseExpiration!=='')
      date2 = moment(state.newLicenseExpiration).toDate();

  let step1, step2, step3;
  let activeStep = step1;

  /*
  STEP 1
  */
  step1 =
  <div>
    <form onSubmit={submitForm}>
      <Row>
        <Col sm="6">
          <Row>
            <Col sm="12">
              <b><i className="fa fa-user"></i>&nbsp;Your Account</b>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>First Name
            </Col>
            <Col sm="8">
              <Input type="text" value={state.session.first_name} readOnly/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Last Name
            </Col>
            <Col sm="8">
              <Input type="text" value={state.session.last_name} readOnly/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Email (username)
            </Col>
            <Col sm="8">
              <Input type="text" value={state.session.email} readOnly/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Password
            </Col>
            <Col sm="8">
              <div className="input-container">
                <Input type={state.showPassword ? 'text' : 'password'} value={state.password} onChange={(e)=>setState({password:e.target.value})}
                  onFocus={handlePasswordFocus}
                  onBlur={handlePasswordBlur}
                  pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                  title="Must contain at least one number, one special character, one uppercase and lowercase letter, and at least 12 or more characters"
                  required
                />
                <span className="toggle-button" onClick={handleToggle}>
                  {state.showPassword ? <i className="fa fa-eye"></i> : <i className="fa fa-eye-slash"></i>}
                </span>
              </div>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="12">
              {state.isFocused && (
                <div id="message" style={{fontSize:'13px'}}>
                  <label>Password must contain the following:</label>
                  <p id="letter" style={{lineHeight:'3px'}} className={(isLowerCaseValid&&isUpperCaseValid)? 'green-color' : 'red-color'}>
                    {(isLowerCaseValid&&isUpperCaseValid)? valid:invalid} Combination of uppercase letters & lowercase letters
                  </p>
                  <p id="number" style={{lineHeight:'3px'}} className={isNumberValid? 'green-color' : 'red-color'}>
                    {isNumberValid? valid:invalid} At least 1 number (0-9)
                  </p>
                  <p id="special-char" style={{lineHeight:'3px'}} className={isSpecialCharacterValid? 'green-color' : 'red-color'}>
                    {isSpecialCharacterValid? valid:invalid} At least 1 special Chracter (!@#$%^&*)
                  </p>
                  <p id="length" style={{lineHeight:'3px'}} className={isLengthValid? 'green-color' : 'red-color'}>
                    {isLengthValid? valid:invalid} Minimum <b>12 characters</b>
                  </p>
                </div>
              )}  
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              Notify Emails
            </Col>
            <Col sm="8">
              <Input type="text" value={state.notifyEmails} onChange={(e)=>setState({notifyEmails:e.target.value})}/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Phone
            </Col>
            <Col sm="8">
              <Input type="text" required={true} value={state.phone} onChange={(e)=>setState({phone:e.target.value})}/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Preffered communication
            </Col>
            <Col sm="8">
              <Input type="select" required={true} value={state.preferredCommunication} onChange={(e)=>{setState({preferredCommunication:e.target.value});}}>
                <option value="SMS">SMS</option>
                <option value="Call">Call</option>
                <option value="Email">Email</option>
              </Input>
            </Col>
          </Row>
        </Col>
        <Col sm='6'>
          <br/>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Tax ID
            </Col>
            <Col sm="8">
              <Input type="text" required={true} value={state.taxID} onChange={(e)=>setState({taxID:e.target.value})}/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>E&O Expiration Date
            </Col>
            <Col sm="8">
              <DatePicker
                required={true}
                className="form-control"
                selected={date}
                onChange={(text)=>{(text)&&setState({eoExpirationDate:text.toLocaleDateString('en-CA')})}}
              />
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>License Number
            </Col>
            <Col sm="8">
              <Input type="text" value={state.session.license_number} readOnly/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>State
            </Col>
            <Col sm="8">
              <Input type="text" value={state.session.state} readOnly/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Type
            </Col>
            <Col sm="8">
              <Input type="select" required={true} onChange={(e)=>{setState({newLicenseType:e.target.value});}} value={state.newLicenseType}>
                <option value="Unknown">Unknown</option>
                <option value="Transitional License">Transitional License</option>
                <option value="License">License</option>
                <option value="Certified Residential">Certified Residential</option>
                <option value="Certified General">Certified General</option>
              </Input>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Expiration
            </Col>
            <Col sm="8">
              <DatePicker
                required={true}
                className="form-control"
                selected={date2}
                onChange={(text)=>{(text)&&setState({newLicenseExpiration:text.toLocaleDateString('en-CA')})}}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="align-right">
        <Button color="warning">Next</Button>
      </div>
    </form>
  </div>

  /*
  STEP 2
  */
  step2 =
  <div>
    <form onSubmit={submitForm}>
      <Row>
        <Col sm="6">
          <Row>
            <Col sm="12">
              <b><i className="fa fa-home"></i>&nbsp;Address</b>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Street
            </Col>
            <Col sm="8">
              <MyPlacesAutocomplete value={state.street} onChange={googlePlaceOnChange} onSelect={googlePlaceOnChange}/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>City
            </Col>
            <Col sm="8">
              <Input required={true} type="text" value={state.city} onChange={(e)=>setState({city:e.target.value})}/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              County
            </Col>
            <Col sm="8">
              <Input type="text" disabled value={state.county} onChange={(e)=>setState({county:e.target.value})}/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>State
            </Col>
            <Col sm="8">
              <Input required={true} type="select" value={state.state} onChange={(e)=>setState({state:e.target.value})}>
                <option key="" value=""></option>
                {states}
              </Input>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Zip
            </Col>
            <Col sm="8">
              <Input required={true} type="text" value={state.zip} onChange={(e)=>setState({zip:e.target.value})}/>
            </Col>
          </Row>
        </Col>
        <Col sm="6">
          <Row>
            <Col sm="2" className='inline-block'>
              <b><i className="fa fa-envelope"></i>&nbsp;Mail Address</b>
            </Col>
            <Col sm="8">
              &nbsp;&nbsp;&nbsp;<Input type="checkbox" value={state.checked} onChange={(e)=>checkHandler(e)}/> Same as <i className="fa fa-home"></i>&nbsp;address
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Street
            </Col>
            <Col sm="8">
              <Input required={true} type="text" value={state.billingStreet} onChange={(e)=>setState({billingStreet:e.target.value})}/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>City
            </Col>
            <Col sm="8">
              <Input required={true} type="text" value={state.billingCity} onChange={(e)=>setState({billingCity:e.target.value})}/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              County
            </Col>
            <Col sm="8">
              <Input type="text" disabled value={state.billingCounty} onChange={(e)=>setState({billingCounty:e.target.value})}/>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>State
            </Col>
            <Col sm="8">
              <Input required={true} type="select" value={state.billingState} onChange={(e)=>setState({billingState:e.target.value})}>
                <option key="" value=""></option>
                {states}
              </Input>
            </Col>
          </Row>
          <Row className="small-padding">
            <Col sm="2">
              <font className="red-color">*</font>Zip
            </Col>
            <Col sm="8">
              <Input required={true} type="text" value={state.billingZip} onChange={(e)=>setState({billingZip:e.target.value})}/>
            </Col>
          </Row>
        </Col>
      </Row>
      <br/>
      <Row>
        <Col sm='5'>
          <i className="fa fa-envelope"></i>&nbsp;<label>Make Check Payable to </label><br/>
          <Input type="text" value={state.billingName} onChange={(e)=>setState({billingName:e.target.value})}/>
        </Col>
      </Row>
      <br/>
      <div className="align-right">
        <Button color="warning">Next</Button>
      </div>
    </form>
  </div>


  /*
  STEP 3
  */
  step3 =
  <div className='ex-large-scroll-container'>
    <form onSubmit={submitForm}>
      <Card>
        <CardHeader className="gray-color">
          General information
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="12">
              <label>Name</label><br/>
              {state.session.first_name+' '+state.session.last_name}
            </Col>
          </Row>
          <Row>
            <Col sm="3">
              <label>Email (username)</label><br/>
              {state.session.email}
            </Col>
            <Col sm="3">
              <label>Password</label><br/>
              {state.password}
            </Col>
          </Row>
          <Row>
            <Col sm="3">
              <label>Notify emails</label><br/>
              {state.notifyEmails}
            </Col>
            <Col sm="3">
              <label>Phone</label><br/>
              {state.phone}
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <label>Preffered communication</label><br/>
              {state.preferredCommunication}
            </Col>
          </Row>

          <div className="my-divider">&nbsp;</div>
          <br/><br/>
          <Row>
            <Col sm="2">
              <label><font className="red-color">*</font>Tax ID</label><br/>
              {state.taxID}
            </Col>
            <Col sm="4">
              <label><font className="red-color">*</font>E&O Expiration Date</label><br/>
              {state.eoExpirationDate}
            </Col>
          </Row>
          <Row>
            <Col sm="3">
              <label><font className="red-color">*</font>License Number</label><br/>
              {state.session.license_number}
            </Col>
            <Col sm="3">
              <label><font className="red-color">*</font>State</label><br/>
              {state.session.state}
            </Col>
            <Col sm="3">
              <label><font className="red-color">*</font>Type</label><br/>
              {state.newLicenseType}
            </Col>
            <Col sm="3">
              <label><font className="red-color">*</font>Expiration</label><br/>
              {state.newLicenseExpiration}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <br/>
      <Card>
        <CardHeader className="gray-color">
          Address
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="5">
              <label>Street</label><br/>
              {state.street}
            </Col>
            <Col sm="4">
              <label>City</label><br/>
              {state.city}
            </Col>
            <Col sm="3">
              <label>County</label><br/>
              {state.county}
            </Col>
          </Row>
          <Row>
            <Col sm="5">
              <label>State</label><br/>
              {state.state}
            </Col>
            <Col sm="4">
              <label>Zip</label><br/>
              {state.zip}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <br/>
      <Card>
        <CardHeader className="gray-color">
          Mail Check To
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="12">
              <label>Make Check Payable To</label><br/>
              {state.billingName}
            </Col>
          </Row>
          <br/><br/>
          <Row>
            <Col sm="5">
              <label>Street</label><br/>
              {state.billingStreet}
            </Col>
            <Col sm="4">
              <label>City</label><br/>
              {state.billingCity}
            </Col>
            <Col sm="3">
              <label>County</label><br/>
              {state.billingCounty}
            </Col>
          </Row>
          <Row>
            <Col sm="5">
              <label>State</label><br/>
              {state.billingState}
            </Col>
            <Col sm="4">
              <label>Zip</label><br/>
              {state.billingZip}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <br/>
      <div className="align-right">
        <Button disabled={state.submitDisabled!==false} onClick={buttonHandler} color="warning">Finish</Button>
      </div>
    </form>
  </div>

  if(state.currentStep===0)
    activeStep = step1;
  else if(state.currentStep===1)
    activeStep = step2;
  else if(state.currentStep===2)
    activeStep = step3;

  if(Object.keys(state.session).length > 0){

    return(
      <div className="login-background">
        <div className="topbar">
            <div className="topbar-logo-container">
              <NavLink to="/"><img className="topbar-logo-img" alt="@Home VMS Logo" width="120px" src="/img/logo_small.png"/></NavLink>
            </div>
            <div className="topbar-action-panel-container">
              <div className="topbar-action-panel">
                <div className="display-inline cursor-pointer" style={{lineHeight:'50px'}}>
                  <a href="https://appraiser.homevms.com/"><i className="fa fa-chevron-left"></i>&nbsp;Back</a>
                </div>
              </div>
              &nbsp;&nbsp;
            </div>
        </div>
        <div className="padding">
          <Card>
            <CardHeader className="header-color">
              <i className="fa fa-info"></i> Create your Account
            </CardHeader>
            <CardBody className="no-padding">
              <div className="padding" style={{background:'white'}}>
                <MyFormStep steps = {state.steps} currentStep = {state.currentStep} updateStep = {updateStep} maxStep={state.maxStep}/>
                <br/>
                {activeStep}
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }else{
    return(
      <div className="login-background" style={{backgroundImage:'url("/img/login_background.jpg")', backgroundAttachment:'fixed', backgroundPosition: 'center center',backgroundRepeat: 'no-repeat',}}>
        <form name="loginForm" onSubmit={onSubmit}>
          <div className="login-container well padding bigger" style={{height:'550px'}}>
            <br/>
            <center>
              <img alt="company logo" src="/img/logo_small.png" className="logo-login"/><br/>
              Appraiser portal - Sign Up
            </center>
            <div className="non-empty-container">
              <p className="no-padding no-margin">{state.errorMessage}</p>
            </div>
            <div className="align-right">
              <br/>
              <NavLink to="/">Back to login</NavLink>
            </div>
            <div className="form-group" style={{height:'38px'}}>
              <Row>
                <Col sm='6'>
                  <label className="font-blue">First Name:</label>
                  <input required={true} type="text" name="firstname" autoComplete="on" onChange={e => setState({fname: e.target.value})} className="form-control"/>
                </Col>
                <Col sm='6'>
                  <label className="font-blue">Last Name:</label>
                  <input required={true} type="text" name="lastname" autoComplete="on" onChange={e => setState({lname: e.target.value})} className="form-control"/>
                </Col>
              </Row>
              <Row>
                <Col sm='12'>
                  <label className="font-blue">Email:</label>
                  <input required={true} type="email"  name="username" autoComplete="on" onChange={e => setState({email: e.target.value})} className="form-control" id="email"/>
                </Col>
              </Row>
              <Row>
                <Col sm='6'>
                  <label className="font-blue">State:</label>
                  <Input required={true} type="select" value={state.licenseState} onChange={(e)=>setState({licenseState:e.target.value})}>
                    <option value=""></option>
                    {states}
                  </Input>
                </Col>
                <Col sm='6'>
                  <label className="font-blue">License #:</label>
                  <input required={true} name="license" autoComplete="on" onChange={e => setState({licenseNumber: e.target.value})} className="form-control"/>
                </Col>
              </Row>
              <Row>
                <Col sm='12'>
                  <br/>
                  <br/>
                  <Button color="warning" className="form-control">Check Account</Button>
                  <br/>
                </Col>
              </Row>
            </div>
            <br/>
          </div>
        </form>
      </div>
    );
  }
}


export default SignUp;
